var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-danger text-center space-box-alert-custom" },
      [
        _c("p", [
          _vm._v(
            "セールモンスターとのチャットワークグループが作成できていません。"
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("以下の手順を確認してチャットワークIDを設定してください。")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("確認でき次第チャットワークグループを作成いたします。")
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("→"),
          _c(
            "a",
            {
              staticClass: "text--underline",
              attrs: {
                href:
                  "https://ssc.salemonster.jp/static/dists/pdf/chatwork.pdf",
                target: "_blank"
              }
            },
            [_c("span", [_vm._v("設定方法")])]
          )
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "※チャットワークグループが作成できていない場合、商品の審査が行われない場合があります。"
          )
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7272d89a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7272d89a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoChatWork.vue
// module id = null
// module chunks = 